import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST,
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS,
  ACTION_EDIT_SITE_GOOGLE_ANALYTICS__SUCCESS,
} from '../actionTypes';


const data = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST:
      return null;

    case ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS:
    case ACTION_EDIT_SITE_GOOGLE_ANALYTICS__SUCCESS:
      return action.payload.siteGoogleAnalytics;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  errors,
});
